module.exports = __webpack_public_path__ + "static/media/MMlogo2.ca0033cb.png";